import type { JSX } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import type { CreateJobPositionFormData } from '../../schemas/jobPosition.schemas';
import type { FormSectionProps } from './types';

function EducationLevelField({
  watch,
  setValue,
  error,
}: Pick<FormSectionProps, 'watch' | 'setValue'> & {
  error?: { message?: string };
}): React.JSX.Element {
  return (
    <div className="space-y-2">
      <Label htmlFor="educationLevel">Education Level</Label>
      <Select
        value={watch('educationLevel') || ''}
        onValueChange={(value) =>
          setValue('educationLevel', value as CreateJobPositionFormData['educationLevel'])
        }
      >
        <SelectTrigger>
          <SelectValue placeholder="Select education level" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="HIGH_SCHOOL">High School</SelectItem>
          <SelectItem value="ASSOCIATE">Associate</SelectItem>
          <SelectItem value="BACHELOR">Bachelor</SelectItem>
          <SelectItem value="MASTER">Master</SelectItem>
          <SelectItem value="PHD">PhD</SelectItem>
        </SelectContent>
      </Select>
      {error && <p className="text-sm text-red-500">{error.message}</p>}
    </div>
  );
}

export function EducationSection({
  register,
  errors,
  setValue,
  watch,
}: FormSectionProps): JSX.Element {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Education & Experience</h3>
      <div className="grid gap-4 sm:grid-cols-2">
        <EducationLevelField watch={watch} setValue={setValue} error={errors.educationLevel} />
        <div className="space-y-2">
          <Label htmlFor="educationField">Education Field</Label>
          <Input id="educationField" {...register('educationField')} />
          {errors.educationField && (
            <p className="text-sm text-red-500">{errors.educationField.message}</p>
          )}
        </div>
      </div>
      <div className="space-y-2">
        <Label htmlFor="yearsOfExperience">Years of Experience</Label>
        <Input id="yearsOfExperience" type="number" {...register('yearsOfExperience')} />
        {errors.yearsOfExperience && (
          <p className="text-sm text-red-500">{errors.yearsOfExperience.message}</p>
        )}
      </div>
    </div>
  );
}
